import { Procedimento } from '@/models/Solicitacao';
import SolicitacoesAPI from '@/features/prescricao-livre/services/SolicitacoesAPI';
import {
  applyDevicesToServiceRequest,
  SharedDevices,
} from '../components/CardSharedDevices/helpers';

async function updateFromSharedDevices(
  requests: Procedimento[],
  sharedDevices: SharedDevices[],
): Promise<Procedimento[]> {
  const hasDevices = sharedDevices.some(group => group.devices.length > 0);

  if (!hasDevices) {
    return requests;
  }

  const devicesByProcedureId = sharedDevices.reduce<
    Map<string, fhir4.Device[]>
  >((acc, group) => {
    group.procedureIds.forEach(procedureId => {
      const currentDevices = acc.get(procedureId) ?? [];
      acc.set(procedureId, [...currentDevices, ...group.devices]);
    });

    return acc;
  }, new Map());

  const updated = await Promise.all(
    requests.map(async request => {
      const serviceRequest = request.pedido;
      const procedureId = serviceRequest.id?.trim() ?? '';

      if (!procedureId) {
        return null;
      }

      const groupDevices = devicesByProcedureId.get(procedureId) ?? [];

      if (groupDevices.length === 0) {
        return null;
      }

      const updatedServiceRequest = applyDevicesToServiceRequest(
        serviceRequest,
        groupDevices,
      );

      if (!updatedServiceRequest) {
        return null;
      }

      return SolicitacoesAPI.update({
        id: request.id.toString(),
        resource: updatedServiceRequest,
        tipo: 'procedimento',
        opts: { session_id: request.session_id },
      });
    }),
  );

  return updated.filter((item): item is Procedimento => item !== null);
}

export default {
  updateFromSharedDevices,
};
